const flights = {
  flight: "Chuyến bay", // translated 
  flights: "Các chuyến bay", // translated 
  originDepartureDate: "Sự khởi hành", // translated 
  destinationDepartureDate: "Trở lại", // translated 
  outbound: "Đầu ra", // translated 
  inbound: "Đầu vào", // translated 
  travelTime: "Thời gian di chuyển", // translated 
  selected: "đã chọn", // translated 
  select: "lựa chọn", // translated 
  airline: "Hãng hàng không", // translated 
  directFlight: "Chuyến bay thẳng", // translated 
  baggage: "Hành lý", // translated 
  stops: "Dừng lại", // translated 
  nonStop: "Không ngừng nghỉ", // translated 
  oneStopMax: "Tối đa một điểm dừng", // translated 
  twoStopsMax: "Tối đa hai điểm dừng", // translated 
  anyStops: "Có bất kỳ điểm dừng nào", // translated 
  smallBaggage: "Hành lý nhỏ", // translated 
  bigBaggage: "Hành lý lớn", // translated 
  smallAndBigBaggage: "Hành lý nhỏ và hành lý lớn", // translated 
  outboundStops: "Điểm dừng đi ra", // translated 
  inboundStops: "Điểm dừng nhập cảnh", // translated 
  selectAirline: "Chọn hãng hàng không", // translated 
  baggageOption: "Tùy chọn hành lý", // translated 
  outboundDepartureAfter: "Khởi hành ra nước ngoài sau", // translated 
  outboundArrivalAfter: "Đến nơi sau khi khởi hành", // translated 
  inboundDepartureAfter: "Khởi hành vào sau", // translated 
  inboundArrivalTimeAfter: "Đến sau khi", // translated 
  flightClass: "Hạng ghế phi công", // translated 
  outboundDepAfter: "Khởi hành sau", // translated 
  outboundArrivalAfrer: "Ra về sau", // translated 
  inboundDepAfter: "Khởi hành sau", // translated 
  inboundArrivalAfter: "Khi đến nơi sau", // translated 
  airlines: "Hãng hàng không", // translated 
  lessThan: "Ít hơn", // translated 
  layover: "Quá cảnh", // translated 
  duration: "Khoảng thời gian", // translated 
  noClassPreference: "Không ưu tiên giai cấp", // translated 
  economy: "Kinh tế", // translated 
  business: "Việc kinh doanh", // translated 
  with: "Với", // translated 
  without: "Không có", // translated 
  twoOrMore: "Hai hoặc nhiều hơn", // translated 
  departure: "Sự khởi hành", // translated 
  return: "Trở lại", // translated 
  submit: "Nộp", // translated 
  priceLessThan: "Giá thấp hơn", // translated 
  durationLessThan: "Thời lượng ngắn hơn", // translated 
  layoverLessThan: "Thời gian quá cảnh ít hơn", // translated 
  noLayover: "Không quá cảnh", // translated 
  durationLowestFirst: "Thời lượng (thấp nhất trước)", // translated 
  durationHighestFirst: "Thời lượng (cao nhất trước)", // translated 
  idType: "Loại ID", // translated 
  idPassportCode: "Mã số định danh/hộ chiếu", // translated 
  expirationDate: "Ngày hết hạn", // translated 
  frequentFlyerNumber: "Mã số khách hàng thường xuyên", // translated 
  frequentFlyerAirline: "Hãng hàng không khách hàng thường xuyên", // translated 
  dateOfBirth: "Ngày sinh", // translated 
  infant: "Trẻ sơ sinh", // translated 
  phone: "Điện thoại", // translated 
  title: "Tiêu đề", // translated 
  noLuggageIncluded: "Không bao gồm hành lý.", // translated 
  includesLuggage: "Bao gồm hành lý", // translated 
  outboundFlight: "Chuyến bay đi", // translated 
  inboundFlight: "Chuyến bay đến", // translated 
  flightNumber: "Số hiệu chuyến bay", // translated 
  flightNumbers: "Số hiệu chuyến bay", // translated 
  cabinClassType: "Loại hạng cabin", // translated 
  class: "Lớp học", // translated 
  aircraft: "Phi cơ", // translated 
  aircraftType: "Loại máy bay", // translated 
  airlineName: "Tên hãng hàng không", // translated 
  no: "KHÔNG", // translated 
  yes: "Đúng", // translated 
  anyFlights: "Bất kỳ chuyến bay nào", // translated 
  oneStop: "Một cửa", // translated 
  direct: "Trực tiếp", // translated 
  directFlights: "Chuyến bay thẳng", // translated 
  all: "Tất cả", // translated 
  first: "Đầu tiên", // translated 
  premiumEconomy: "Kinh tế ưu tú", // translated 
  withBaggageOnly: "Chỉ bao gồm hành lý", // translated 
  oneWay: "Một chiều", // translated 
  roundTrip: "Khứ hồi", // translated 
  withBaggage: "Có hành lý", // translated 
  noBaggagePreference: "Không có yêu cầu về hành lý", // translated 
  noBaggage: "Không có hành lý", // translated 
  requiredFields: "Các trường bắt buộc", // translated 
  nonRequiredFields: "Các trường không bắt buộc", // translated 
  cabinClass: "Hạng thương gia", // translated 
  brandName: "Tên thương hiệu", // translated 
  performNewSearch: "Thực hiện tìm kiếm mới", // translated 
  outboundDeparture: "Khởi hành đi", // translated 
  inboundDeparture: "Khởi hành đến", // translated 
  created: "Tạo", // translated 
  freeCancellationAvailable: "Có thể hủy đặt phòng miễn phí.", // translated 
  freeCancellationDeadline: "Hạn chót hủy miễn phí", // translated 
  externalReference: "Tham chiếu bên ngoài", // translated 
  outboundflightNumber: "Số hiệu chuyến bay đi", // translated 
  inboundflightNumber: "Số hiệu chuyến bay đến", // translated 
  arrival: "Đến", // translated 
  originAirport: "Sân bay xuất phát", // translated 
};


export default flights;
